module.exports = __webpack_public_path__ + "static/img/article.71421ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/article.png
// module id = WHSB
// module chunks = 1